<template>
  <Layout :page="'Chỉnh sửa phiên bản'" @submit="submit = $event">
      <ValidationObserver ref="observerItems">
        <b-form @submit.stop.prevent>

          <LayoutCard>
            <LayoutCardTitle>Thuộc tính </LayoutCardTitle>

            <LayoutCardNote>
              <b>Thuộc tính sản phẩm</b> có thể là Kích thước, Màu sắc, Chất liệu…
              <br />
              <b>Giá trị của thuộc tính</b> có thể là S - M - L (Kích thước),
              Xanh - Đỏ - Hồng (Màu sắc), Vải Cotton - Da lộn - Lụa (Chất liệu).
            </LayoutCardNote>

            <b-table
              head-variant="light"
              tbody-tr-class="row-table-class"
              hover
              :items="optionsItem"
              :fields="fieldProperty"
              v-if="showTableVariations"
            >
              <template #cell(name)="data">
                {{ data.item.name }}
              </template>

              <template #cell(values)="data">
                {{ data.item.values.join(", ") }}
              </template>
            </b-table>

            <LayoutControl>
              <BaseButton
                variant="outline-dashed"
                type="button"
                @click="showPopup('them-thuoc-tinh')"
                :disabled="!showTableVariations"
              >
                <template #icon-before>
                  <i class="fa-solid fa-plus"></i>
                </template>
                Thêm thuộc tính
              </BaseButton>
            </LayoutControl>
          </LayoutCard>

          <LayoutCard>
            
            <LayoutCardTitle>Thiết lập phiên bản</LayoutCardTitle>

            <LayoutCardNote>
              <b>Phiên bản sản phẩm</b> được tạo ra từ các tuỳ chọn thuộc tính
            </LayoutCardNote>

            <el-dropdown
              v-if="allowDisplayQuickActionVariations"
              trigger="click"
              placement="bottom-start"
            >
              <el-button type="secondary">
                Thao tác nhanh
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <popup-set-value :selected="selectedBox" type="priceExport" text="Áp dụng nhanh giá bán" @result="onResult"></popup-set-value>
                </el-dropdown-item>
                <el-dropdown-item>
                  <popup-set-value :selected="selectedBox" type="priceImport" text="Áp dụng nhanh giá nhập" @result="onResult"></popup-set-value>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span type="button" @click="checkBarcode()">Tạo mã vạch tự động</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span 
                    type="button" 
                    @click="clickBarcodeChooseMore"
                  >
                    In mã vạch</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <div
              style="overflow-x: auto; max-width: 100%; width: 100%"
              v-if="!showTableVariations"
            >
              <b-table
                :items="Item.variations"
                :fields="fieldVariationOnly.filter(e => e.show)"
                :key="updateUI"
              >
                <template #head(edit)>
                  <i class="fa-solid fa-bars btn-icon" @click="showPopup('Cai-dat-hien-thi')"></i>
                </template>
                <template v-slot:head(selected)>
                  <b-form-checkbox v-model="checkboxAll" @change="selectAll" />
                </template>
                <template
                  #cell(selected)="data"
                >
                  <b-form-checkbox
                    v-model="selectedBox"
                    :value="data.item"
                    @change="checkItem(data.item)"
                  />
                </template>

                <template #cell(name)="data">
                  {{ data.item.name === "" ? "Mặc định" : data.item.name }}
                </template>

                <template #cell(sku)="data">
                  <BaseInput
                    :placeholder="'Nhập SKU'"
                    v-model="data.item.sku"
                    type="SKU_UPC"
                    :rules="'SKU|lBetween:1,16'"
                    :validate="Item.validate.sku"
                    :disabled="Item.validate.isDisabledSKU"
                    @blur="checkSKU(data.item.sku)"
                  />
                </template>

                <template #cell(upc)="data">
                  <BaseInput class="upc-input"
                    :placeholder="'Nhập Barcode/UPC'"
                    v-model="data.item.upc"
                    name="Barcode"
                    :rules="'BARCODE|lBetween:5,13'"
                    :validate="Item.validate.upc"
                    :btn="true"
                    type="SKU_UPC"
                    @blur="checkUPC(data.item.upc)"
                  >
                    <template #btn-input v-if="Item.upc == ''">
                      <span class="text-primary" @click="generateBarcode()">Tạo</span>
                    </template>
                  </BaseInput>
                </template>

                <template #cell(importPrice)="data">
                  <BaseInput
                    v-model="data.item.prices.importPrice"
                    type="money"
                  />
                </template>

                <template #cell(exportPrice)="data">
                  <BaseInput
                    v-model="data.item.prices.exportPrice"
                    type="money"
                  />
                </template>
              </b-table>
            </div>
            <div
              style="overflow-x: auto; max-width: 100%; width: 100%"
              v-if="showTableVariations"
            >
              <b-table
                :items="Item.variations"
                :fields="fieldsVariation.filter(e => e.show)"
                :key="updateUI"
              >
               <template #head(edit)>
                  <i class="fa-solid fa-bars btn-icon" @click="showPopup('Cai-dat-hien-thi')"></i>
                </template>
                <template v-slot:head(selected)>
                  <b-form-checkbox v-model="checkboxAll" @change="selectAll" />
                </template>
                <template
                  #cell(selected)="data"
                >
                  <b-form-checkbox
                    v-model="selectedBox"
                    :value="data.item"
                    @change="checkItem(data.item)"
                  />
                </template>
                <template #cell(images)="data">
                  <ItemSelectImage
                    :value="data.item"
                    :list="listImages"
                    @value="data.item.images = $event"
                  />
                </template>

                <template #cell(name)="data">
                  <BaseInput
                    :placeholder="'Nhập tên hiển thị'"
                    v-model="data.item.name"
                  />
                </template>

                <template #cell(sku)="data">
                  <BaseInput
                    placeholder="Nhập SKU"
                    v-model="data.item.sku"
                    type="SKU_UPC"
                    :rules="'SKU|lBetween:1,16'"
                    :validate="data.item.validate.sku"
                    :disabled="data.item.validate.isDisabledSKU"
                    @blur="checkSKU(data.item.sku, data.index)"
                  />
                </template>

                <template #cell(upc)="data">
                  <BaseInput class="upc-input"
                    placeholder="Nhập Barcode/UPC"
                    v-model="data.item.upc"
                    :rules="'BARCODE|lBetween:5,13'"
                    :validate="data.item.validate.upc"
                    :btn="true"
                    type="SKU_UPC"
                    @blur="checkUPC(data.item.upc, data.index)"
                  >
                    <template #btn-input  v-if="data.item.upc == ''">
                      <span class="text-primary" @click="generateBarcode(data.index)">Tạo</span>
                    </template>
                  </BaseInput>
                </template>

                <template #cell(importPrice)="data">
                  <BaseInput
                    v-model="data.item.prices.importPrice"
                    type="money"
                  />
                </template>

                <template #cell(exportPrice)="data">
                  <BaseInput
                    v-model="data.item.prices.exportPrice"
                    type="money"
                  />
                </template>
              </b-table>
            </div>

          </LayoutCard>
        </b-form>
      </ValidationObserver>

      <ItemArrangeColumn
        v-model="listFields"
        @value="
          showTableVariations
          ? (fieldsVariation = $event)
          : (fieldVariationOnly = $event)
        "
      />

      <ItemOption
        :options="optionsItem"
        @options="handleVariation($event)"
        :type="showTableVariationsTmp ? `detail-item` : ''"
      />


      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>

      <PopupCheckBarcode
        :existedUpc="existedUpc"
        :selectedBox="selectedBox"
        @getValue="inputUpcForRecords($event)"
        type="variations"
      />
  </Layout>
</template>

<script>
import Swal from "sweetalert2";
import Layout from "@/router/layouts/item";
import ItemOption from "@/pages/items/components/ItemOption.vue";
import ItemSelectImage from "@/pages/items/components/ItemSelectImage.vue";
import ItemArrangeColumn from "@/pages/items/components/ItemArrangeColumn.vue";
import PopupCheckBarcode from "@/pages/items/components/PopupCheckBarcode"

import formatNumber from "@/mixins/items/formatNumber";
import dublicate from "@/mixins/items/checkDublicate";
//import getDetailItem from "@/mixins/items/getDetailItem";
import getDetailItemCompound from "@/mixins/items/getDetailItem";
import handlerReqUpdateItem from "@/mixins/items/handlerReqUpdateItem";
import genBarcode from "@/mixins/items/handleBarcode"
import PopupSetValue from '@/components/popup-add-quick/popup-set-value';

import { ProductService } from "@/services/nextshop/product.service";
import { getCurrentMerchant } from '../../utils/auth';
import { variationsItem, variationsOnlyItem } from '@/utils/fieldsTable.js'
export default {
  components: {
    Layout,
    ItemOption,
    ItemSelectImage,
    ItemArrangeColumn,
    PopupCheckBarcode,
    PopupSetValue
  },

  mixins: [
    dublicate,
    //getDetailItem,
    getDetailItemCompound,
    formatNumber,
    handlerReqUpdateItem,
    genBarcode,
  ],

  data() {
    return {
      checkboxAll: false,
      updateUI: 1,
      showNote: false,
      submit: false,
      showTableVariations: false,
      showTableVariationsTmp: false,
      loading: false,
      disabledSubmit: false,
      importPrice: '',
      exportPrice: '',
      selectedBox: [],
      tabs: [
        { id: 0, text: "Thông tin phiên bản" },
        { id: 1, text: "Tồn kho" },
      ],
      fieldsVariation: variationsItem,
      fieldProperty: [
        {
          label: "Thuộc tính",
          key: "name",
          thStyle: { width: "30%" },
        },
        {
          label: "Giá trị",
          key: "values",
          thStyle: { width: "50%" },
        },
      ],
      fieldVariationOnly: variationsOnlyItem,
      optionsItem: [
        {
          name: "",
          values: [""],
        },
      ],
      avatar: {
        nameOption: "Phien-ban-goc",
        images: [],
      },
      listImages: [],
      listFields: [],
      Item: {
        name: "",
        unit: "",
        weightInGram: 0,
        categoryId: "",
        metaSearchable: {
          brand: "",
          isSelling: false,
          category: "",
          statusDefault: false,
          statusImei: false,
          statusBatch: false
        },
        validate: {
          sku: "",
          upc: "",
        },
        description: "",
        images: [],
        options: [],
        sku: "",
        upc: "",
        tags: [],
        unit: {
          name: "",
          additionalUnits: [],
        },
        variations: [],
        selected: false,
        priceItem: [
          {
            exportPrice: 0,
            importPrice: 0,
          },
        ],
        warranty: {
          description: "",
          dueAtInMinute: "3021-01-26T20:14:52.036Z",
          duration: 0,
          timeUnit: "",
          warrantyName: "",
        },
      },
      existedUpc: [],
      inforMerchant: getCurrentMerchant(),
      dataItems: [],
      check:false,
    };
  },

  async created() {
    try {
      this.loading = true;
      await this.getDataItem();
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    
    async getDataItem() {
      try {
        //const response = await this.getDetailItem(this.$route.params.id);
        const params = {itemId: this.$route.params.id }
        const response = await this.getDetailItemCompound(params);
        
        if (response) {
          this.Item = {
            ...response,
            variations: response.variations.map(vari => {
              return {
                ...vari,
                variations: response.variations
              }
            })
          }
        }
        
        console.log(this.Item.variations)

        this.optionsItem =
          this.Item.options.length > 0
            ? this.Item.options.map((e) => {
                return {
                  ...e,
                  disabled: false,
                };
              })
            : this.optionsItem;

        this.showTableVariationsTmp =
          this.Item.options.length;
        this.showTableVariations = this.Item.options.length > 0;

        this.listFields = !this.showTableVariations
          ? [...this.fieldVariationOnly]
          : [...this.fieldsVariation];

      } catch (error) {
        console.log(error);
      }
    },

    clickBarcodeChooseMore () {
      if(this.selectedBox.length > 0){
        this.selectedBox.map((item) => {
          let oneItem = {
            "amount": this.checkNumReplaceComma(item.prices.exportPrice),
            "images": item.images,
            "itemVariationId": item.itemVariationId,
            "lineItemId": (this.$route.params.id) ? this.$route.params.id : Math.random()*100,
            "mcName": this.inforMerchant.name,
            "name": item.name,
            "quantity": 0,
            "sku": item.sku,
            "unitPrice": this.checkNumReplaceComma(item.prices.exportPrice),
            "upc": item.upc
          }
          this.dataItems.push(oneItem)
        })
        this.saveStorage()
        this.$router.push({ path: '/barcode/choose' })
      }
    },

    saveStorage () {
      localStorage.setItem('itemBarcode', JSON.stringify(this.dataItems))
    },

    async generateBarcode(index) {
      try {
        const resBarcode = await this.genBarcode(1)
        if (!this.showTableVariations) {
          this.Item.variations[0].upc = resBarcode
        } else {
          this.Item.variations[index].upc = resBarcode
        }

        if (this.selectedBox.length > 0) {
          this.existedUpc.push(this.Item.variations[index])
        }
      } catch (error) {
        console.log(error);
      }
    },

    async checkUPC(value, index) {
      this.disabledSubmit = true;

      const result = await this.checkDublicate("upc", value);

      if (result) {
        this.disabledSubmit = true;
      } else {
        this.disabledSubmit = false;
      }

      if (index === undefined && result) {
        this.Item.validate.upc = "Mã UPC đã tồn tại";
      } else if (index != undefined && result) {
        this.Item.variations[index].validate.upc = "Mã UPC đã tồn tại";
      } else if (index === undefined && !result) {
        this.Item.validate.upc = "";
      } else if (index != undefined && !result) {
        this.Item.variations[index].validate.upc = "";
      }
    },

    handleVariation($event) {
      if ($event.length != 0) {
        this.optionsItem = $event;

        let variationTmp = [];
        let options = this.optionsItem.map((e) => e.values);

        const combinations = options.reduce((arrA, arrB) =>
          arrA.reduce((x, y) => x.concat(arrB.map((e) => [].concat(y, e))), [])
        );

        // optionsVariations để format các trường trong option của mỗi phiên bản (for req call api)
        const optionsVariations = combinations.map((e) => {
          return Array.isArray(e)
            ? // TH: có nhiều hơn 1 thuộc tính
              e.map((item, index) => {
                return {
                  name: this.optionsItem[index].name,
                  description: "",
                  value: item,
                  values: [item],
                };
              })
            : // TH: có 1 thuộc tính
              [
                {
                  name: this.optionsItem[0].name,
                  description: "",
                  value: e,
                  values: [e],
                },
              ];
        });

        optionsVariations.map((e, index) => {
          const name = `${
            // TH: Có nhiều hơn 1 thuộc tính và tên sản phẩm khác rỗng
            Array.isArray(combinations[index]) && this.Item.name != ""
              ? this.Item.name + "-" + combinations[index].join("-")
              : // TH: Có nhiều hơn 1 thuộc tính và tên sản phẩm = rỗng
              Array.isArray(combinations[index]) && this.Item.name == ""
              ? combinations[index].join("-")
              : // TH: chỉ có 1 thuộc tính và tên sản phẩm khác rỗng
              !Array.isArray(combinations[index]) && this.Item.name != ""
              ? this.Item.name + "-" + combinations[index]
              : // TH: chỉ có 1 thuộc tính và tên sản phẩm = rỗng
                combinations[index]
          }`;

          const price = {
            name: name,
            exportPrice: this.checkNumReplaceComma(
              this.Item.priceItem.exportPrice
            ),
            importPrice: this.checkNumReplaceComma(
              this.Item.priceItem.importPrice
            ),
          };

          const result = this.Item.variations.findIndex(
            (itemVariation) =>
              JSON.stringify(e) === JSON.stringify(itemVariation.options)
          );

          if (result != -1) {
            variationTmp.push(this.Item.variations[result]);
          } else {
            const variation = {
              ordinal: 0,
              weightGram: 0,
              widthCentimeter: 0,
              widthInCentimeter: 0,
              heightCentimeter: 0,
              heightInCentimeter: 0,
              lengthCentimeter: 0,
              lengthInCentimeter: 0,
              variationId: "",
              itemVariationId: "",
              images: [],
              weightInGram:
                typeof this.Item.weightInGram === "string"
                  ? parseInt(this.Item.weightInGram.replace(/,/g, ""))
                  : this.Item.weightInGram,

              name: name,
              nameOption: Array.isArray(combinations[index])
                ? combinations[index].join("-") : combinations[index],
              options: e,
              prices: price,
              sku: '',
              upc: '',
              validate: {
                upc: "",
              },
              unitMass: "gr",
              selected: false,
            }

            variationTmp.push(variation);
          }
        });
        this.Item.variations = variationTmp;
        this.showTableVariations = true;
      } else {
        this.showTableVariations = false;
        this.listFields = [...this.fieldVariationOnly];
        this.Item.variations = [{
          name: "Mặc định",
          exportPrice: 0,
          importPrice: 0,
          sku: "",
          upc: "",
          unit: "",
        }]
        this.optionsItem = [
          {
            name: "",
            values: [""],
          },
        ];
      }
    },

    selectAll() {
      if (this.checkboxAll) {
        this.selectedBox = this.Item.variations
      } else {
        this.selectedBox = []
      }
    },

    async checkSKU(value, index) {
      this.disabledSubmit = true;

      const result = await this.checkDublicate("sku", value);

      if (result) {
        this.disabledSubmit = true;
      } else {
        this.disabledSubmit = false;
      }

      if (index === undefined && result) {
        this.Item.validate.sku = "Mã SKU đã tồn tại";
      } else if (index != undefined && result) {
        this.Item.variations[index].validate.sku = "Mã SKU đã tồn tại";
      } else if (index === undefined && !result) {
        this.Item.validate.sku = "";
      } else if (index != undefined && !result) {
        this.Item.variations[index].validate.sku = "";
      }
    },

    async checkDublicate(type, value) {
      try {
        const list =
          this.Item.variations.length > 0
            ? this.Item.variations.map((e) => e[type])
            : [];
        const result = this.dublicate(value, list);

        const params = {
          pagingAndSorting: { limit: 10, lastIndex: "", sortOrder: "DESC" },
          queryString:
            "{variations." + `${type}` + "}=='''" + `${value}` + "'''",
        };

        const response =
          value != "" ? await ProductService.getList(params) : { data: [] };

        if (
          (response.data.length > 0 &&
            response.data[0].itemId != this.Item.id) ||
          result
        ) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    
    inputUpcForRecords(data) {
      data.map((element) => {
        const index = this.Item.variations.findIndex(
          (variation) => element.itemVariationId === variation.itemVariationId
        );

        this.Item.variations[index].upc = element.upc
      });

      this.$bvToast.toast(`Tạo mã vạch thành công!`, {
        title: `Thông báo`,
        autoHideDelay: `3000`,
        variant: `success`,
        toaster: `b-toaster-top-center`,
        solid: true,
        appendToast: true,
      });
      
      this.selectedBox = [];
    },
    
    onResult(obj) {
        this.Item.variations.forEach(varia => {
          const checkExist = this.selectedBox.find(select => select.variationId === varia.variationId)
          if (checkExist) {
            if (obj.type === 'priceImport') {
              varia.prices.importPrice = obj.value
            } else if (obj.type === 'priceExport') {
              varia.prices.exportPrice = obj.value
            }
          }
        })
    },
    
    checkBarcode() {
      this.existedUpc  = this.selectedBox.filter((e) => (e.upc != ""))
      if (this.existedUpc.length != 0) {
        this.showPopup("check-barcode")
      } else {
        this.selectedBox.map((e,index) => {
          if (e.upc === "") {
            this.generateBarcode(index)
          }
        })
        this.$bvToast.toast(`Tạo mã vạch thành công!`, {
          title: `Thông báo`,
          autoHideDelay: `3000`,
          variant: `success`,
          toaster: `b-toaster-top-center`,
          solid: true,
          appendToast: true,
        });
      }
    },

    
    checkItem(obj) {
      const checkExist = this.selectedBox.findIndex(select => select.itemVariationId === obj.itemVariationId)
      if (checkExist === -1) {
        this.selectedBox.concat(obj)
      }
      if (this.selectedBox.length === this.Item.variations.length) {
        this.checkboxAll = true
        this.selectAll()
      } else {
        this.checkboxAll = false
      }
    },

    async updateItem() {
      this.loading = true;

      const itemPriceReq = await this.handlerReqUpdateItem(
        this.Item,
        this.optionsItem
      );
      const params = {
        itemReq: {
          id: this.Item.id,
          optimisticVersion: this.Item.version,
          variations: [
            ...this.Item.variations,
          ],
          options: this.optionsItem
        },
        itemPriceReq: itemPriceReq
      };

      if(this.optionsItem.length == 1 && this.optionsItem[0].name == ''){
        delete params.itemReq['options']
      }
      
      const response = await ProductService.updateItem(params);
      this.loading = false;
      if(response.success){
        Swal.fire({
          icon: "success",
          title: 'Thành công',
          text: 'Cập nhật sản phẩm thành công',
          confirmButtonText: "Xác nhận",
        }).then(() => {
          this.$router.push(`/items/items-detail/${this.$route.params.id}`);
        });
      }else{
        Swal.fire({
          icon: "error",
          title: 'Thất bại',
          text: 'Cập nhật sản phẩm thất bại',
          confirmButtonText: "Xác nhận",
        })
      }
    }
  },

  computed: {
    allowDisplayQuickActionVariations() {
      return this.selectedBox.length > 0
    }
  },
  

  watch: {
    submit() {
      this.updateItem()
    }
  },
};
</script>

<style lang="scss" scoped>
.box-dashed {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px;
  font-weight: 500;
  font-size: 14px;
  border: 1px dashed #9eb4fa;
  border-radius: 4px;
  background-color: #fff;
  color: #3e69f6;
  cursor: pointer;
  i {
    padding-right: 5px;
  }
}


.isSelling {
  display: flex;
  align-items: center;
  height: 100%;

  & > *:not(*:first-child) {
    margin-left: 10px;
  }
}

.field_check_box {
  display: flex;
  align-self: center;

  .check_box {
    display: flex;
    margin-right: 30px;
  }
}

::v-deep .upc-input {
  .__wrap {
    width: 190px;

    .__input {
      text-transform: uppercase;
    }
  }
}
.text-head-modal{
    color: #000;
    font-size: 15px;
    line-height: 20px;
    text-align: left;
    background: #f0f0f0;
    padding: 8px 10px;
  }
  .text-head-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .text-des-active{
    text-align: center;
    width: 90%;
    margin: 0 auto;
  }
  .box-modals .btn {
    margin: 0 5px;
  }
  .line-active{
    border-top: 1px solid #ddd;
    padding-top: 12px;
  }
  .btn-closed{
    padding:10px 15px;
  }
  .arrTabs{
    display:inline-block;
    width: 100%;
  }
  .arrTabs li{
    display:inline-block;
    font-weight: bold;
    font-size: 20px;
    color: #a7acb1;
    cursor: pointer;
  }
  .arrTabs li.active{
    color: #23313E;
  }
  .card_wall{
    border-left: 2px solid #B9B9B9;
    margin: 0px 20px;
    display: inline-block;
    height: 22px;
    position: relative;
    top: 5px;
  }
</style>
